import firebaseApp from "../firebase/credenciales";
import { getFirestore, doc, setDoc, updateDoc } from "firebase/firestore";
import escribirLog from "./escribirLog";
async function addRecordWithId(infoDocumento, autor, baseDatos, titleLog, docId) {
    const db = getFirestore(firebaseApp);
    const firestoreRef = doc(db, baseDatos, docId);
    try {
        await setDoc(firestoreRef, infoDocumento);
    } catch (error) {
        console.error('Error al agregar el registro:', docId);
        throw error;
    }

    //agregar el identificador
    await updateDoc(firestoreRef, {
        id: firestoreRef.id
    });

    let uid = firestoreRef.id
    //verificar si se genero el identificador de firebase de 20 caracteres
    if (uid.length === 8 || uid.length === 9) {
        escribirLog(titleLog, infoDocumento, autor);
    } else {
        uid = null
    }

    return uid
}

export default addRecordWithId;
